export default "__VITE_ASSET__DYM5$dSk__"